{
  "about.blocks": "受管制的伺服器",
  "about.contact": "聯絡我們：",
  "about.default_locale": "預設",
  "about.disclaimer": "Mastodon 是一個自由的開源軟體，是 Mastodon gGmbH 之註冊商標。",
  "about.domain_blocks.no_reason_available": "無法存取的原因",
  "about.domain_blocks.preamble": "Mastodon 基本上允許您瀏覽聯邦宇宙中任何伺服器的內容並與使用者互動。以下是於本伺服器上設定之例外。",
  "about.domain_blocks.silenced.explanation": "一般來說您不會看到來自這個伺服器的個人檔案與內容，除非您明確地檢視或著跟隨此個人檔案。",
  "about.domain_blocks.silenced.title": "已受限",
  "about.domain_blocks.suspended.explanation": "來自此伺服器的資料都不會被處理、儲存或交換，也無法和此伺服器上的使用者互動與交流。",
  "about.domain_blocks.suspended.title": "已停權",
  "about.language_label": "語言",
  "about.not_available": "無法於本伺服器上使用此資訊。",
  "about.powered_by": "由 {mastodon} 提供之去中心化社群媒體",
  "about.rules": "伺服器規則",
  "account.account_note_header": "個人備註",
  "account.activity": "活動",
  "account.add_note": "新增個人備註",
  "account.add_or_remove_from_list": "自列表中新增或移除",
  "account.badges.admin": "管理員",
  "account.badges.blocked": "已封鎖",
  "account.badges.bot": "機器人",
  "account.badges.domain_blocked": "已封鎖網域",
  "account.badges.group": "群組",
  "account.badges.muted": "已靜音",
  "account.badges.muted_until": "靜音直至 {until}",
  "account.block": "封鎖 @{name}",
  "account.block_domain": "封鎖來自 {domain} 網域之所有內容",
  "account.block_short": "封鎖",
  "account.blocked": "已封鎖",
  "account.cancel_follow_request": "收回跟隨請求",
  "account.copy": "複製個人檔案連結",
  "account.direct": "私訊 @{name}",
  "account.disable_notifications": "取消來自 @{name} 嘟文之通知",
  "account.edit_note": "編輯個人備註",
  "account.edit_profile": "編輯個人檔案",
  "account.edit_profile_short": "編輯",
  "account.enable_notifications": "當 @{name} 發嘟時通知我",
  "account.endorse": "於個人檔案推薦",
  "account.familiar_followers_many": "被 {name1}、{name2}、及{othersCount, plural, other {其他您認識的 # 人}} 跟隨",
  "account.familiar_followers_one": "被 {name1} 跟隨",
  "account.familiar_followers_two": "被 {name1} 與 {name2} 跟隨",
  "account.featured": "精選內容",
  "account.featured.accounts": "個人檔案",
  "account.featured.collections": "收藏名單",
  "account.featured.new_collection": "新收藏名單",
  "account.field_overflow": "顯示完整內容",
  "account.filters.all": "所有活動",
  "account.filters.boosts_toggle": "顯示轉嘟",
  "account.filters.posts_boosts": "嘟文與轉嘟",
  "account.filters.posts_only": "嘟文",
  "account.filters.posts_replies": "嘟文與回嘟",
  "account.filters.replies_toggle": "顯示回嘟",
  "account.follow": "跟隨",
  "account.follow_back": "跟隨回去",
  "account.follow_back_short": "跟隨回去",
  "account.follow_request": "跟隨",
  "account.follow_request_cancel": "取消跟隨請求",
  "account.follow_request_cancel_short": "取消",
  "account.follow_request_short": "跟隨請求",
  "account.followers": "跟隨者",
  "account.followers.empty": "尚未有人跟隨此使用者。",
  "account.followers_counter": "被 {count, plural, other {{counter} 人}}跟隨",
  "account.followers_you_know_counter": "{counter} 位您認識的跟隨者",
  "account.following": "跟隨中",
  "account.following_counter": "正在跟隨 {count,plural,other {{counter} 人}}",
  "account.follows.empty": "此使用者尚未跟隨任何人。",
  "account.follows_you": "已跟隨您",
  "account.go_to_profile": "前往個人檔案",
  "account.hide_reblogs": "隱藏來自 @{name} 之轉嘟",
  "account.in_memoriam": "謹此悼念。",
  "account.join_modal.day": "日",
  "account.join_modal.me": "您加入 {server} 的時間為",
  "account.join_modal.me_anniversary": "歡慶聯邦宇宙週年！您加入 {server} 的時間為",
  "account.join_modal.me_today": "這是您在 {server} 的第一天！",
  "account.join_modal.other": "{name} 加入 {server} 的時間為",
  "account.join_modal.other_today": "這是 {name} 在 {server} 的第一天！",
  "account.join_modal.share.celebrate": "發一則慶祝嘟文",
  "account.join_modal.share.intro": "發一則介紹嘟文",
  "account.join_modal.share.welcome": "發一則歡迎嘟文",
  "account.join_modal.years": "{number, plural, other {年}}",
  "account.joined_short": "加入時間",
  "account.languages": "變更訂閱的語言",
  "account.last_active": "上次活躍時間",
  "account.link_verified_on": "已於 {date} 檢查此連結的擁有者權限",
  "account.locked_info": "此帳號的隱私狀態被設為鎖定。該擁有者會手動審核能跟隨此帳號的人。",
  "account.media": "媒體",
  "account.mention": "提及 @{name}",
  "account.menu.add_to_list": "新增至列表...",
  "account.menu.block": "封鎖帳號",
  "account.menu.block_domain": "封鎖 {domain}",
  "account.menu.copied": "複製帳號連結至剪貼簿",
  "account.menu.copy": "複製連結",
  "account.menu.direct": "私訊",
  "account.menu.hide_reblogs": "於時間軸中隱藏轉嘟",
  "account.menu.mention": "提及",
  "account.menu.mute": "靜音帳號",
  "account.menu.note.description": "僅有您可見",
  "account.menu.open_original_page": "於 {domain} 檢視",
  "account.menu.remove_follower": "移除跟隨者",
  "account.menu.report": "檢舉帳號",
  "account.menu.share": "分享...",
  "account.menu.show_reblogs": "於時間軸中顯示轉嘟",
  "account.menu.unblock": "解除封鎖帳號",
  "account.menu.unblock_domain": "解除封鎖 {domain}",
  "account.menu.unmute": "取消靜音帳號",
  "account.moved_to": "{name} 目前的新帳號為：",
  "account.mute": "靜音 @{name}",
  "account.mute_notifications_short": "靜音推播通知",
  "account.mute_short": "靜音",
  "account.muted": "已靜音",
  "account.mutual": "跟隨彼此",
  "account.name.copy": "複製帳號",
  "account.name.help.domain": "{domain} 為託管此使用者個人檔案與嘟文之伺服器。",
  "account.name.help.domain_self": "{domain} 為託管您個人檔案與嘟文之伺服器。",
  "account.name.help.footer": "就像是您能與使用不同電子郵件提供商的其他人互動一般，您能與其他 Mastodon 伺服器上的人們互動，也能與其他 Fediverse 上的任何人互動。",
  "account.name.help.header": "@handle 就像是 email 地址一樣",
  "account.name.help.username": "{username} 為該使用者於他們伺服器上的帳號名稱。其他伺服器上的某個人可能擁有一樣的使用者名稱。",
  "account.name.help.username_self": "{username} 為您於此伺服器上的帳號名稱。其他伺服器上的某個人可能擁有一樣的使用者名稱。",
  "account.name_info": "這是什麼？",
  "account.no_bio": "無個人檔案描述。",
  "account.node_modal.callout": "僅有您能見到您的個人備註。",
  "account.node_modal.edit_title": "編輯個人備註",
  "account.node_modal.error_unknown": "無法儲存此筆記",
  "account.node_modal.field_label": "個人備註",
  "account.node_modal.save": "儲存",
  "account.node_modal.title": "新增個人備註",
  "account.note.edit_button": "編輯",
  "account.note.title": "個人備註（僅有您可見）",
  "account.open_original_page": "檢視原始頁面",
  "account.pending": "等待中",
  "account.posts": "嘟文",
  "account.remove_from_followers": "自跟隨者中移除 {name}",
  "account.report": "檢舉 @{name}",
  "account.requested_follow": "{name} 要求跟隨您",
  "account.share": "分享 @{name} 的個人檔案",
  "account.show_reblogs": "顯示來自 @{name} 的轉嘟",
  "account.statuses_counter": "{count, plural, other {{counter} 則嘟文}}",
  "account.timeline.pinned": "已釘選",
  "account.timeline.pinned.view_all": "檢視所有釘選嘟文",
  "account.unblock": "解除封鎖 @{name}",
  "account.unblock_domain": "解除封鎖網域 {domain}",
  "account.unblock_domain_short": "解除封鎖",
  "account.unblock_short": "解除封鎖",
  "account.unendorse": "取消於個人檔案推薦對方",
  "account.unfollow": "取消跟隨",
  "account.unmute": "解除靜音 @{name}",
  "account.unmute_notifications_short": "解除靜音推播通知",
  "account.unmute_short": "解除靜音",
  "account_edit.advanced_settings.bot_hint": "告知他人此帳號主要執行自動化操作且可能未受人為監控",
  "account_edit.advanced_settings.bot_label": "機器人帳號",
  "account_edit.advanced_settings.title": "進階設定",
  "account_edit.bio.add_label": "新增個人簡介",
  "account_edit.bio.edit_label": "編輯個人簡介",
  "account_edit.bio.placeholder": "加入一段簡短介紹以幫助其他人識別您。",
  "account_edit.bio.title": "個人簡介",
  "account_edit.bio_modal.add_title": "新增個人簡介",
  "account_edit.bio_modal.edit_title": "編輯個人簡介",
  "account_edit.column_button": "完成",
  "account_edit.column_title": "編輯個人檔案",
  "account_edit.custom_fields.add_label": "新增欄位",
  "account_edit.custom_fields.edit_label": "編輯欄位",
  "account_edit.custom_fields.placeholder": "加入您的稱謂、外部連結、或其他您想分享的。",
  "account_edit.custom_fields.reorder_button": "重新排序欄位",
  "account_edit.custom_fields.tip_content": "您能透過驗證任何您擁有網站之連結，以輕鬆增加您 Mastodon 帳號之可信度。",
  "account_edit.custom_fields.tip_title": "小撇步：新增驗證連結",
  "account_edit.custom_fields.title": "自訂欄位",
  "account_edit.custom_fields.verified_hint": "如何新增驗證連結？",
  "account_edit.display_name.add_label": "新增顯示名稱",
  "account_edit.display_name.edit_label": "編輯顯示名稱",
  "account_edit.display_name.placeholder": "您的顯示名稱是您將於個人檔案與時間軸的出現方式。",
  "account_edit.display_name.title": "顯示名稱",
  "account_edit.featured_hashtags.edit_label": "新增主題標籤",
  "account_edit.featured_hashtags.placeholder": "協助其他人識別、以及快速存取您的最愛主題。",
  "account_edit.featured_hashtags.title": "推薦主題標籤",
  "account_edit.field_actions.delete": "刪除欄位",
  "account_edit.field_actions.edit": "編輯欄位",
  "account_edit.field_delete_modal.confirm": "您確定要刪除此自訂欄位嗎？此動作無法復原。",
  "account_edit.field_delete_modal.delete_button": "刪除",
  "account_edit.field_delete_modal.title": "是否刪除自訂欄位？",
  "account_edit.field_edit_modal.add_title": "新增自訂欄位",
  "account_edit.field_edit_modal.discard_confirm": "捨棄",
  "account_edit.field_edit_modal.discard_message": "您有尚未儲存之變更。您是否確定要捨棄這些變更？",
  "account_edit.field_edit_modal.edit_title": "編輯自訂欄位",
  "account_edit.field_edit_modal.length_warning": "已超過建議字數。行動裝置使用者可能無法檢視您的欄位完整內容。",
  "account_edit.field_edit_modal.link_emoji_warning": "我們不建議於 URL 中使用自訂 emoji 表情符號。為了避免使用者混淆，包含兩者之自訂欄位將僅顯示為文字，而不是顯示為連結。",
  "account_edit.field_edit_modal.name_hint": "例如：「個人網站」",
  "account_edit.field_edit_modal.name_label": "標籤",
  "account_edit.field_edit_modal.url_warning": "如欲新增連結，請於開頭包含 {protocol}。",
  "account_edit.field_edit_modal.value_hint": "例如「https://example.me」",
  "account_edit.field_edit_modal.value_label": "值",
  "account_edit.field_reorder_modal.drag_cancel": "拖放操作已取消。欄位「{item}」已放置。",
  "account_edit.field_reorder_modal.drag_end": "欄位「{item}」已放置。",
  "account_edit.field_reorder_modal.drag_instructions": "請按空白鍵或 Enter 重新整理自訂欄位。使用方向鍵上下移動欄位。按下空白鍵或 Enter 鍵於新位置放置欄位，或按下 ESC 鍵取消。",
  "account_edit.field_reorder_modal.drag_move": "欄位「{item}」已移動。",
  "account_edit.field_reorder_modal.drag_over": "欄位「{item}」已移動至「{over}」上方。",
  "account_edit.field_reorder_modal.drag_start": "已選取欄位「{item}」。",
  "account_edit.field_reorder_modal.handle_label": "拖放欄位「{item}」",
  "account_edit.field_reorder_modal.title": "重新整理欄位",
  "account_edit.image_alt_modal.add_title": "新增 ALT 說明文字",
  "account_edit.image_alt_modal.details_content": "要：<ul> <li>根據圖片描述自己</li> <li>使用第三人稱（例如用「小明」代替「我」）</li> <li>言簡意賅，寥寥數語足矣</li> </ul> 不要：<ul> <li>從「照片」開頭，這對螢幕閱讀程式來說是多餘的</li> </ul> 範例：<ul> <li>「小明穿著綠色襯衫，戴著眼鏡」</li> </ul>",
  "account_edit.image_alt_modal.details_title": "小撇步：個人檔案照片的 ALT 說明文字",
  "account_edit.image_alt_modal.edit_title": "編輯 ALT 說明文字",
  "account_edit.image_alt_modal.text_hint": "ALT 說明文字可協助螢幕閱讀程式使用者理解您的內容。",
  "account_edit.image_alt_modal.text_label": "ALT 說明文字",
  "account_edit.image_delete_modal.confirm": "您確定要刪除此圖片嗎？此動作無法復原。",
  "account_edit.image_delete_modal.delete_button": "刪除",
  "account_edit.image_delete_modal.title": "是否刪除圖片？",
  "account_edit.image_edit.add_button": "新增圖片",
  "account_edit.image_edit.alt_add_button": "新增 ALT 說明文字",
  "account_edit.image_edit.alt_edit_button": "編輯 ALT 說明文字",
  "account_edit.image_edit.remove_button": "移除圖片",
  "account_edit.image_edit.replace_button": "替換圖片",
  "account_edit.item_list.delete": "刪除 {name}",
  "account_edit.item_list.edit": "編輯 {name}",
  "account_edit.name_modal.add_title": "新增顯示名稱",
  "account_edit.name_modal.edit_title": "編輯顯示名稱",
  "account_edit.profile_tab.button_label": "自訂",
  "account_edit.profile_tab.hint.description": "這些設定能自訂使用者在官方應用程式中於 {server} 所見之內容，但可能不適用於其他伺服器或第三方應用程式的使用者。",
  "account_edit.profile_tab.hint.title": "檢視結果仍可能有所不同",
  "account_edit.profile_tab.show_featured.description": "「精選內容」為您能展現其他帳號之可選分頁。",
  "account_edit.profile_tab.show_featured.title": "顯示「精選內容」分頁",
  "account_edit.profile_tab.show_media.description": "「媒體」為顯示您包含圖片或影片嘟文之可選分頁。",
  "account_edit.profile_tab.show_media.title": "顯示「媒體」分頁",
  "account_edit.profile_tab.show_media_replies.description": "當啟用時，媒體分頁將顯示您的嘟文與對其他人嘟文之回嘟。",
  "account_edit.profile_tab.show_media_replies.title": "於「媒體」分頁中包含回嘟",
  "account_edit.profile_tab.show_relations.description": "於您的個人檔案中顯示您正在跟隨中之帳號與您的跟隨者。其他人仍可見您正在跟隨他們。",
  "account_edit.profile_tab.show_relations.title": "顯示「跟隨者」與「正在跟隨」",
  "account_edit.profile_tab.subtitle": "客製化您的個人檔案頁面顯示方式。",
  "account_edit.profile_tab.title": "個人檔案顯示設定",
  "account_edit.save": "儲存",
  "account_edit.upload_modal.back": "上一步",
  "account_edit.upload_modal.done": "完成",
  "account_edit.upload_modal.next": "下一步",
  "account_edit.upload_modal.step_crop.zoom": "縮放",
  "account_edit.upload_modal.step_upload.button": "瀏覽檔案",
  "account_edit.upload_modal.step_upload.dragging": "拖曳以上傳",
  "account_edit.upload_modal.step_upload.header": "選擇圖片",
  "account_edit.upload_modal.step_upload.hint": "WEBP、PNG、GIF 或 JPG 格式，最大 {limit}MB。{br}圖片將會縮放至 {width}x{height} 像素。",
  "account_edit.upload_modal.title_add.avatar": "新增個人檔案照片",
  "account_edit.upload_modal.title_add.header": "新增封面圖片",
  "account_edit.upload_modal.title_replace.avatar": "更換個人檔案照片",
  "account_edit.upload_modal.title_replace.header": "更換封面圖片",
  "account_edit.verified_modal.details": "藉由驗證連結至個人網站增加您 Mastodon 個人檔案之可信度。運作方式如下：",
  "account_edit.verified_modal.invisible_link.details": "新增連結至您的標頭 (header)。其重要的部分是 rel=\"me\" ，防止透過使用者產生內容模擬。您甚至能使用頁面標頭之 link 標籤取代頁面中的 {tag}，但 HTML 必須能於不執行 JavaScript 情況下所存取。",
  "account_edit.verified_modal.invisible_link.summary": "如何隱藏此連結？",
  "account_edit.verified_modal.step1.header": "複製下面的 HTML 程式碼並貼至您網站的標頭 (header) 中",
  "account_edit.verified_modal.step2.details": "若您已將您的網站新增至自訂欄位，您需要刪除並重新加入以觸發驗證。",
  "account_edit.verified_modal.step2.header": "將您的網站加入為自訂欄位",
  "account_edit.verified_modal.title": "如何新增驗證連結",
  "account_edit_tags.add_tag": "加入 #{tagName}",
  "account_edit_tags.column_title": "編輯主題標籤",
  "account_edit_tags.help_text": "推薦主題標籤幫助其他人發現並與您的個人檔案互動。它們將作為過濾器出現於您個人檔案頁面之動態中。",
  "account_edit_tags.max_tags_reached": "您已達推薦主題標籤數量上限。",
  "account_edit_tags.search_placeholder": "請輸入主題標籤…",
  "account_edit_tags.suggestions": "建議：",
  "account_edit_tags.tag_status_count": "{count, plural, other {# 則嘟文}}",
  "account_list.hidden_notice": "僅您可見。如欲向他人展示此列表，請前往 <link>{page} > {modal} > {field}</link>。",
  "account_list.total": "{total, plural, other {# 個帳號}}",
  "account_note.placeholder": "點擊以新增備註",
  "admin.dashboard.daily_retention": "註冊後使用者存留率（日）",
  "admin.dashboard.monthly_retention": "註冊後使用者存留率（月）",
  "admin.dashboard.retention.average": "平均",
  "admin.dashboard.retention.cohort": "註冊月份",
  "admin.dashboard.retention.cohort_size": "新使用者",
  "admin.impact_report.instance_accounts": "此伺服器之個人檔案將被刪除",
  "admin.impact_report.instance_followers": "此伺服器之跟隨者將流失",
  "admin.impact_report.instance_follows": "彼伺服器之跟隨者將流失",
  "admin.impact_report.title": "影響總結",
  "alert.rate_limited.message": "請於 {retry_time, time, medium} 後重試。",
  "alert.rate_limited.title": "已限速",
  "alert.unexpected.message": "發生非預期的錯誤。",
  "alert.unexpected.title": "哎呀！",
  "alt_text_badge.title": "ALT 說明文字",
  "alt_text_modal.add_alt_text": "新增 ALT 說明文字",
  "alt_text_modal.add_text_from_image": "自圖片新增 ALT 說明文字",
  "alt_text_modal.cancel": "取消",
  "alt_text_modal.change_thumbnail": "變更預覽圖",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "替聽覺障礙人士描述...",
  "alt_text_modal.describe_for_people_with_visual_impairments": "替視覺障礙人士描述...",
  "alt_text_modal.done": "完成",
  "announcement.announcement": "公告",
  "annual_report.announcement.action_build": "建立我的 Mastodon 年度回顧 (Wrapstodon)",
  "annual_report.announcement.action_dismiss": "不需要，謝謝",
  "annual_report.announcement.action_view": "檢視我的 Mastodon 年度回顧 (Wrapstodon)",
  "annual_report.announcement.description": "探索更多關於您過去一年於 Mastodon 上的互動情況。",
  "annual_report.announcement.title": "您的 Mastodon 年度回顧 {year} 已抵達",
  "annual_report.nav_item.badge": "新報告",
  "annual_report.shared_page.donate": "捐款",
  "annual_report.shared_page.footer": "由 Mastodon 團隊 {heart} 產生",
  "annual_report.shared_page.footer_server_info": "{username} 使用 {domain}，運行 Mastodon 的眾多社群之一。",
  "annual_report.summary.archetype.booster.desc_public": "{name} 持續追尋值得轉嘟的嘟文，以精準眼光放大其他創作者之影響力。",
  "annual_report.summary.archetype.booster.desc_self": "您持續追尋值得轉嘟的嘟文，以精準眼光放大其他創作者之影響力。",
  "annual_report.summary.archetype.booster.name": "弓箭手",
  "annual_report.summary.archetype.die_drei_fragezeichen": "？？？",
  "annual_report.summary.archetype.lurker.desc_public": "我們知道 {name} 曾於聯邦宇宙的某個角落駐足，以靜謐的方式獨享 Mastodon。",
  "annual_report.summary.archetype.lurker.desc_self": "我們知道您曾於聯邦宇宙的某個角落駐足，以靜謐的方式獨享 Mastodon。",
  "annual_report.summary.archetype.lurker.name": "斯多葛主義信徒",
  "annual_report.summary.archetype.oracle.desc_public": "{name} 發表的新嘟文多於回嘟，使 Mastodon 注入活力並展望未來。",
  "annual_report.summary.archetype.oracle.desc_self": "您發表的新嘟文多於回嘟，使 Mastodon 注入活力並展望未來。",
  "annual_report.summary.archetype.oracle.name": "先知",
  "annual_report.summary.archetype.pollster.desc_public": "{name} 發起投票多於其他嘟文類型，使 Mastodon 充滿探索與好奇。",
  "annual_report.summary.archetype.pollster.desc_self": "您發起投票多於其他嘟文類型，使 Mastodon 充滿探索與好奇。",
  "annual_report.summary.archetype.pollster.name": "探究者",
  "annual_report.summary.archetype.replier.desc_public": "{name} 經常回覆他人嘟文，替 Mastodon 帶來源源不絕的新討論。",
  "annual_report.summary.archetype.replier.desc_self": "您經常回覆他人嘟文，替 Mastodon 帶來源源不絕的新討論。",
  "annual_report.summary.archetype.replier.name": "花蝴蝶",
  "annual_report.summary.archetype.reveal": "揭露我的類型稱號",
  "annual_report.summary.archetype.reveal_description": "感謝您成為 Mastodon 的一分子！是時候揭曉您於 {year} 年份的代表類型。",
  "annual_report.summary.archetype.title_public": "{name} 的類型稱號",
  "annual_report.summary.archetype.title_self": "您的類型稱號",
  "annual_report.summary.close": "關閉",
  "annual_report.summary.copy_link": "複製連結",
  "annual_report.summary.followers.new_followers": "{count, plural, other {位新跟隨者}}",
  "annual_report.summary.highlighted_post.boost_count": "此嘟文被轉嘟 {count, plural, other {# 次}}。",
  "annual_report.summary.highlighted_post.favourite_count": "此嘟文被加入最愛 {count, plural, other {# 次}}。",
  "annual_report.summary.highlighted_post.reply_count": "此嘟文獲得 {count, plural, other {# 則回覆}}。",
  "annual_report.summary.highlighted_post.title": "最受歡迎的嘟文",
  "annual_report.summary.most_used_app.most_used_app": "最常使用的應用程式",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "最常使用的主題標籤",
  "annual_report.summary.most_used_hashtag.used_count": "您於 {count, plural, other {# 則嘟文}}中使用此主題標籤。",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} 於 {count, plural, other {# 則嘟文}}中使用此主題標籤。",
  "annual_report.summary.new_posts.new_posts": "新嘟文",
  "annual_report.summary.percentile.text": "<topLabel>這讓您成為前</topLabel><percentage></percentage><bottomLabel>{domain} 的使用者。</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "我們不會告訴 Bernie。",
  "annual_report.summary.share_elsewhere": "分享至其他地方",
  "annual_report.summary.share_message": "我獲得 {archetype} 稱號！",
  "annual_report.summary.share_on_mastodon": "於 Mastodon 上分享",
  "attachments_list.unprocessed": "（未處理）",
  "audio.hide": "隱藏音訊",
  "block_modal.no_collections": "您們雙方都無法將對方加入收藏名單。如適用，您們將自動自彼此現有收藏名單中移除。",
  "block_modal.remote_users_caveat": "我們會要求 {domain} 伺服器尊重您的決定。然而，我們無法保證所有伺服器皆會遵守，某些伺服器可能以不同方式處理封鎖。未登入之使用者仍可能看見您的公開嘟文。",
  "block_modal.show_less": "減少顯示",
  "block_modal.show_more": "顯示更多",
  "block_modal.they_cant_mention": "您無法提及、跟隨、或引用彼此。",
  "block_modal.they_cant_see_posts": "他們無法讀取您的嘟文，且您不會見到他們的嘟文。",
  "block_modal.they_will_know": "他們能見到他們已被封鎖。",
  "block_modal.title": "是否封鎖該使用者？",
  "block_modal.you_wont_see_mentions": "您將不會見到其他人提及他們的嘟文。",
  "boost_modal.combo": "您下次可以按 {combo} 跳過",
  "boost_modal.reblog": "是否要轉嘟？",
  "boost_modal.undo_reblog": "是否要取消轉嘟？",
  "bundle_column_error.copy_stacktrace": "複製錯誤報告",
  "bundle_column_error.error.body": "無法繪製請求的頁面。這可能是因為我們程式碼中的臭蟲或是瀏覽器相容問題。",
  "bundle_column_error.error.title": "糟糕！",
  "bundle_column_error.network.body": "嘗試載入此頁面時發生錯誤。這可能是因為您的網際網路連線或此伺服器有暫時性的問題。",
  "bundle_column_error.network.title": "網路錯誤",
  "bundle_column_error.retry": "重試",
  "bundle_column_error.return": "返回首頁",
  "bundle_column_error.routing.body": "找不到請求的頁面。您是否確定網址列中的 URL 是正確的？",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "關閉",
  "bundle_modal_error.message": "載入此畫面時發生錯誤。",
  "bundle_modal_error.retry": "重試",
  "callout.dismiss": "關閉",
  "carousel.current": "<sr>頁面</sr> {current, number} / {max, number}",
  "carousel.slide": "{max, number} 頁中之第 {current, number} 頁",
  "character_counter.recommended": "{currentLength}/{maxLength} 個建議字數",
  "character_counter.required": "{currentLength}/{maxLength} 個字",
  "closed_registrations.other_server_instructions": "因為 Mastodon 是去中心化的，所以您也能於其他伺服器上建立帳號，並仍然與此伺服器互動。",
  "closed_registrations_modal.description": "目前無法於 {domain} 建立新帳號，但也請別忘了，您並不一定需要有 {domain} 伺服器的帳號，也能使用 Mastodon。",
  "closed_registrations_modal.find_another_server": "尋找另一個伺服器",
  "closed_registrations_modal.preamble": "Mastodon 是去中心化的，所以無論您於哪個伺服器新增帳號，都可以與此伺服器上的任何人跟隨及互動。您甚至能自行架設自己的伺服器！",
  "closed_registrations_modal.title": "註冊 Mastodon",
  "collection.share_modal.share_link_label": "分享連結",
  "collection.share_modal.share_via_post": "於 Mastodon 上發嘟文",
  "collection.share_modal.share_via_system": "分享至...",
  "collection.share_modal.title": "分享收藏名單",
  "collection.share_modal.title_new": "分享您的新收藏名單！",
  "collection.share_template_other": "來看看這個酷酷的收藏名單：{link}",
  "collection.share_template_own": "來看看我的新收藏名單：{link}",
  "collections.account_count": "{count, plural, other {# 個帳號}}",
  "collections.accounts.empty_description": "加入最多 {count} 個帳號",
  "collections.accounts.empty_editor_title": "此收藏名單尚未有任何人",
  "collections.accounts.empty_title": "此收藏名單是空的",
  "collections.block_collection_owner": "封鎖帳號",
  "collections.by_account": "來自 {account_handle}",
  "collections.collection_description": "說明",
  "collections.collection_language": "語言",
  "collections.collection_language_none": "無",
  "collections.collection_name": "名稱",
  "collections.collection_topic": "主題",
  "collections.confirm_account_removal": "您是否確定要自此收藏名單中移除此帳號？",
  "collections.content_warning": "內容警告",
  "collections.continue": "繼續",
  "collections.copy_link": "複製連結",
  "collections.copy_link_confirmation": "複製收藏名單連結至剪貼簿",
  "collections.create.accounts_title": "您想於此收藏名單推薦誰？",
  "collections.create.basic_details_title": "基本資料",
  "collections.create.steps": "步驟 {step}/{total}",
  "collections.create_collection": "建立收藏名單",
  "collections.delete_collection": "刪除收藏名單",
  "collections.description_length_hint": "100 字限制",
  "collections.detail.author_added_you_on_date": "{author} 於 {date} 將您加入",
  "collections.detail.loading": "讀取收藏名單中...",
  "collections.detail.revoke_inclusion": "移除我",
  "collections.detail.sensitive_content": "敏感內容",
  "collections.detail.sensitive_note": "此收藏名單可能包含對某些使用者敏感之帳號或內容。",
  "collections.detail.share": "分享此收藏名單",
  "collections.detail.you_are_in_this_collection": "您已被加入至此收藏名單",
  "collections.edit_details": "編輯詳細資料",
  "collections.error_loading_collections": "讀取收藏名單時發生錯誤。",
  "collections.hidden_accounts_description": "您已封鎖或靜音{count, plural, other {這些使用者}}",
  "collections.hidden_accounts_link": "{count, plural, other {# 個隱藏帳號}}",
  "collections.hints.accounts_counter": "{count}/{max} 個帳號",
  "collections.last_updated_at": "最後更新：{date}",
  "collections.list.collections_with_count": "{count, plural, other {# 份收藏名單}}",
  "collections.list.created_by_author": "由 {name} 建立",
  "collections.list.created_by_you": "由您建立",
  "collections.list.featuring_you": "您為名單成員",
  "collections.manage_accounts": "管理帳號",
  "collections.mark_as_sensitive": "標記為敏感內容",
  "collections.mark_as_sensitive_hint": "將此收藏名單之說明隱藏於內容警告之後。此收藏名單名稱仍將可見。",
  "collections.maximum_collection_count_description": "您的伺服器允許新增至多 {count} 個收藏名單。",
  "collections.maximum_collection_count_reached": "您所建立之收藏名單數量已達上限",
  "collections.name_length_hint": "40 字限制",
  "collections.new_collection": "新增收藏名單",
  "collections.pending_accounts.message": "當我們正在等來自使用者或他們伺服器之回應時，帳號可能暫時顯示為等待中狀態。僅有您能見到等待中帳號。",
  "collections.pending_accounts.title": "為什麼我看到等待中帳號？",
  "collections.remove_account": "移除",
  "collections.report_collection": "檢舉此收藏名單",
  "collections.revoke_collection_inclusion": "將我自此收藏名單中移除",
  "collections.revoke_inclusion.confirmation": "您已自「{collection}」中被移除",
  "collections.revoke_inclusion.error": "發生錯誤，請稍候重試。",
  "collections.search_accounts_label": "搜尋帳號以加入",
  "collections.search_accounts_max_reached": "您新增之帳號數已達上限",
  "collections.sensitive": "敏感內容",
  "collections.share_short": "分享",
  "collections.suggestions.can_not_add": "無法被新增",
  "collections.suggestions.can_not_add_desc": "這些帳號可能選擇退出探索功能，或他們所在之伺服器未支援收藏名單。",
  "collections.suggestions.must_follow": "您必須先跟隨",
  "collections.suggestions.must_follow_desc": "這些帳號審查所有跟隨請求。跟隨者才能將他們加入至收藏名單內。",
  "collections.topic_hint": "新增主題標籤以協助其他人瞭解此收藏名單之主題。",
  "collections.topic_special_chars_hint": "特殊字元將於儲存時被移除",
  "collections.unlisted_collections_description": "這些將不會於您的個人檔案對他人顯示。但任何擁有連結之人皆能發現其內容。",
  "collections.unlisted_collections_with_count": "未公開收藏名單 ({count})",
  "collections.view_collection": "檢視收藏名單",
  "collections.visibility_public": "公開",
  "collections.visibility_public_hint": "可於搜尋結果與其他推薦處可見。",
  "collections.visibility_title": "可見性",
  "collections.visibility_unlisted": "不公開",
  "collections.visibility_unlisted_hint": "任何擁有連結的人可見。但隱藏於搜尋結果與推薦中。",
  "column.about": "關於",
  "column.blocks": "已封鎖使用者",
  "column.bookmarks": "書籤",
  "column.community": "本站時間軸",
  "column.create_list": "建立列表",
  "column.direct": "私訊",
  "column.directory": "瀏覽個人檔案",
  "column.domain_blocks": "已封鎖網域",
  "column.edit_list": "編輯列表",
  "column.favourites": "最愛",
  "column.firehose": "即時內容",
  "column.firehose_local": "本站伺服器之即時內容",
  "column.firehose_singular": "即時內容",
  "column.follow_requests": "跟隨請求",
  "column.home": "首頁",
  "column.list_members": "管理列表成員",
  "column.lists": "列表",
  "column.mutes": "已靜音使用者",
  "column.notifications": "推播通知",
  "column.other_collections": "{name} 的收藏名單",
  "column.pins": "釘選的嘟文",
  "column.public": "聯邦時間軸",
  "column.your_collections": "您的收藏名單",
  "column_back_button.label": "上一頁",
  "column_header.hide_settings": "隱藏設定",
  "column_header.moveLeft_settings": "將欄位向左移動",
  "column_header.moveRight_settings": "將欄位向右移動",
  "column_header.pin": "釘選",
  "column_header.show_settings": "顯示設定",
  "column_header.unpin": "取消釘選",
  "column_search.cancel": "取消",
  "combobox.close_results": "關閉結果",
  "combobox.loading": "讀取中",
  "combobox.no_results_found": "此搜尋查無結果",
  "combobox.open_results": "開啟結果",
  "combobox.results_available": "{count, plural, other {# 個建議}}可用。請使用上下方向鍵移動。按下 Enter 鍵選擇。",
  "community.column_settings.local_only": "僅顯示本站",
  "community.column_settings.media_only": "僅顯示媒體",
  "community.column_settings.remote_only": "僅顯示遠端",
  "compose.error.blank_post": "嘟文無法為空白。",
  "compose.language.change": "變更語言",
  "compose.language.search": "搜尋語言...",
  "compose.published.body": "發嘟成功。",
  "compose.published.open": "開啟",
  "compose.saved.body": "已儲存嘟文。",
  "compose_form.direct_message_warning_learn_more": "了解更多",
  "compose_form.encryption_warning": "Mastodon 上的嘟文並未進行端到端加密。請不要透過 Mastodon 分享任何敏感資訊。",
  "compose_form.hashtag_warning": "由於這則嘟文設定為「不公開」，它將不被列於任何主題標籤下。只有公開的嘟文才能藉由主題標籤被找到。",
  "compose_form.lock_disclaimer": "您的帳號尚未 {locked}。任何人皆能跟隨您並看到您設定成僅有跟隨者可見的嘟文。",
  "compose_form.lock_disclaimer.lock": "上鎖",
  "compose_form.placeholder": "正在想些什麼嗎？",
  "compose_form.poll.duration": "投票期限",
  "compose_form.poll.multiple": "多選",
  "compose_form.poll.option_placeholder": "選項 {number}",
  "compose_form.poll.single": "單選",
  "compose_form.poll.switch_to_multiple": "變更投票為允許多個選項",
  "compose_form.poll.switch_to_single": "變更投票為允許單一選項",
  "compose_form.poll.type": "投票方式",
  "compose_form.publish": "發嘟",
  "compose_form.reply": "回覆",
  "compose_form.save_changes": "更新",
  "compose_form.spoiler.marked": "移除內容警告",
  "compose_form.spoiler.unmarked": "新增內容警告",
  "compose_form.spoiler_placeholder": "內容警告 (非必填)",
  "confirmation_modal.cancel": "取消",
  "confirmations.block.confirm": "封鎖",
  "confirmations.delete.confirm": "刪除",
  "confirmations.delete.message": "您確定要刪除這則嘟文嗎？",
  "confirmations.delete.title": "是否刪除該嘟文？",
  "confirmations.delete_collection.confirm": "刪除",
  "confirmations.delete_collection.message": "此動作無法復原。",
  "confirmations.delete_collection.title": "是否刪除 「{name}」？",
  "confirmations.delete_list.confirm": "刪除",
  "confirmations.delete_list.message": "您確定要永久刪除此列表嗎？",
  "confirmations.delete_list.title": "是否刪除該列表？",
  "confirmations.discard_draft.confirm": "捨棄並繼續",
  "confirmations.discard_draft.edit.cancel": "恢復編輯",
  "confirmations.discard_draft.edit.message": "繼續將捨棄任何您對正在編輯的此嘟文進行之任何變更。",
  "confirmations.discard_draft.edit.title": "是否捨棄對您的嘟文之變更？",
  "confirmations.discard_draft.post.cancel": "恢復草稿",
  "confirmations.discard_draft.post.message": "繼續將捨棄您正在撰寫中之嘟文。",
  "confirmations.discard_draft.post.title": "是否捨棄您的嘟文草稿？",
  "confirmations.discard_edit_media.confirm": "捨棄",
  "confirmations.discard_edit_media.message": "您於媒體描述或預覽區塊有未儲存的變更。是否要捨棄這些變更？",
  "confirmations.follow_to_list.confirm": "跟隨並加入至列表",
  "confirmations.follow_to_list.message": "您必須先跟隨 {name} 以將其加入至列表。",
  "confirmations.follow_to_list.title": "是否跟隨該使用者？",
  "confirmations.hide_featured_tab.confirm": "隱藏分頁",
  "confirmations.hide_featured_tab.intro": "您可以於<i>編輯個人檔案→個人檔案分頁設定</i>下變更此設定。",
  "confirmations.hide_featured_tab.message": "這將會隱藏 {serverName} 及其他執行最新版本 Mastodon 伺服器上使用者所見之分頁。其他介面顯示可能有所不同。",
  "confirmations.hide_featured_tab.title": "是否隱藏「精選內容」分頁？",
  "confirmations.logout.confirm": "登出",
  "confirmations.logout.message": "您確定要登出嗎？",
  "confirmations.logout.title": "您確定要登出嗎？",
  "confirmations.missing_alt_text.confirm": "新增 ALT 說明文字",
  "confirmations.missing_alt_text.message": "您的嘟文中的多媒體內容未附上 ALT 說明文字。添加說明文字描述能幫助更多人存取您的內容。",
  "confirmations.missing_alt_text.secondary": "仍要發嘟",
  "confirmations.missing_alt_text.title": "是否新增 ALT 說明文字？",
  "confirmations.mute.confirm": "靜音",
  "confirmations.private_quote_notify.cancel": "返回至編輯",
  "confirmations.private_quote_notify.confirm": "發表嘟文",
  "confirmations.private_quote_notify.do_not_show_again": "不再顯示此訊息",
  "confirmations.private_quote_notify.message": "您所引用與提及之使用者將被通知且能檢視您的嘟文，即便他們並無跟隨您。",
  "confirmations.private_quote_notify.title": "是否和跟隨者與提及使用者分享此內容？",
  "confirmations.quiet_post_quote_info.dismiss": "不要再提醒我",
  "confirmations.quiet_post_quote_info.got_it": "了解",
  "confirmations.quiet_post_quote_info.message": "當引用不於公開時間軸顯示之嘟文時，您的嘟文將自熱門時間軸隱藏。",
  "confirmations.quiet_post_quote_info.title": "引用不於公開時間軸顯示之嘟文",
  "confirmations.redraft.confirm": "刪除並重新編輯",
  "confirmations.redraft.message": "您確定要刪除這則嘟文並重新編輯嗎？您將失去此嘟文之轉嘟及最愛，且對原嘟文之回覆將變成獨立嘟文。",
  "confirmations.redraft.title": "是否刪除並重新編輯該嘟文？",
  "confirmations.remove_from_followers.confirm": "移除跟隨者",
  "confirmations.remove_from_followers.message": "{name} 將停止跟隨您。您確定要繼續嗎？",
  "confirmations.remove_from_followers.title": "是否移除該跟隨者？",
  "confirmations.revoke_collection_inclusion.confirm": "移除我",
  "confirmations.revoke_collection_inclusion.message": "此操作永久有效，且該收藏名單之擁有者無法稍候將您再次加入至此收藏名單。",
  "confirmations.revoke_collection_inclusion.title": "是否將您自此收藏名單中移除？",
  "confirmations.revoke_quote.confirm": "移除嘟文",
  "confirmations.revoke_quote.message": "此動作無法復原。",
  "confirmations.revoke_quote.title": "是否移除該嘟文？",
  "confirmations.unblock.confirm": "解除封鎖",
  "confirmations.unblock.title": "是否解除封鎖 {name}？",
  "confirmations.unfollow.confirm": "取消跟隨",
  "confirmations.unfollow.title": "是否取消跟隨 {name}？",
  "confirmations.withdraw_request.confirm": "收回跟隨請求",
  "confirmations.withdraw_request.title": "是否收回對 {name} 之跟隨請求？",
  "content_warning.hide": "隱藏嘟文",
  "content_warning.show": "仍要顯示",
  "content_warning.show_more": "顯示更多",
  "content_warning.show_short": "顯示",
  "conversation.delete": "刪除對話",
  "conversation.mark_as_read": "標記為已讀",
  "conversation.open": "檢視對話",
  "conversation.with": "與 {names}",
  "copy_icon_button.copied": "已複製到剪貼簿",
  "copy_icon_button.copy_this_text": "複製連結至剪貼簿",
  "copypaste.copied": "已複製",
  "copypaste.copy_to_clipboard": "複製到剪貼簿",
  "directory.federated": "來自已知聯邦宇宙",
  "directory.local": "僅來自 {domain}",
  "directory.new_arrivals": "新人",
  "directory.recently_active": "最近活躍",
  "disabled_account_banner.account_settings": "帳號設定",
  "disabled_account_banner.text": "您的帳號 {disabledAccount} 目前已停用。",
  "dismissable_banner.community_timeline": "這些是託管於 {domain} 上帳號之最新公開嘟文。",
  "dismissable_banner.dismiss": "關閉",
  "dismissable_banner.public_timeline": "這些是聯邦宇宙上來自 {domain} 使用者們跟隨中帳號所發表之最新公開嘟文。",
  "domain_block_modal.block": "封鎖伺服器",
  "domain_block_modal.block_account_instead": "改為封鎖 @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "來自此伺服器之使用者能與您以往的嘟文互動。",
  "domain_block_modal.they_cant_follow": "來自此伺服器之使用者將無法跟隨您。",
  "domain_block_modal.they_wont_know": "他們不會知道他們已被封鎖。",
  "domain_block_modal.title": "是否封鎖該網域？",
  "domain_block_modal.you_will_lose_num_followers": "您將失去 {followersCount, plural, other {{followersCountDisplay} 個跟隨者}} 與 {followingCount, plural, other {{followingCountDisplay} 個您跟隨之帳號}}。",
  "domain_block_modal.you_will_lose_relationships": "您將失去所有的跟隨者與您自此伺服器跟隨之帳號。",
  "domain_block_modal.you_wont_see_posts": "您將不會見到來自此伺服器使用者之任何嘟文或推播通知。",
  "domain_pill.activitypub_lets_connect": "它使您能於 Mastodon 及其他不同的社群應用程式與人連結及互動。",
  "domain_pill.activitypub_like_language": "ActivityPub 像是 Mastodon 與其他社群網路溝通時所用的語言。",
  "domain_pill.server": "伺服器",
  "domain_pill.their_handle": "他們的帳號：",
  "domain_pill.their_server": "他們數位世界的家，他們所有的嘟文都在這裡。",
  "domain_pill.their_username": "他們於他們的伺服器中獨一無二的識別。於不同的伺服器上可能找到具有相同帳號的使用者。",
  "domain_pill.username": "使用者名稱",
  "domain_pill.whats_in_a_handle": "什麼是帳號 (@handle) ？",
  "domain_pill.who_they_are": "由於帳號 (@handle) 能說明某人是誰以及他們來自何方，您能於 <button>支援 ActivityPub 的平臺</button> 之社群網路上與人們互動。",
  "domain_pill.who_you_are": "由於帳號 (@handle) 能說明您是誰以及您來自何方，人們能於 <button>支援 ActivityPub 的平臺</button> 之社群網路上與您互動。",
  "domain_pill.your_handle": "您的帳號：",
  "domain_pill.your_server": "您數位世界的家，您所有的嘟文都在這裡。不喜歡這台伺服器嗎？您能隨時搬家至其他伺服器並且仍保有您的跟隨者。",
  "domain_pill.your_username": "您於您的伺服器中獨一無二的識別。於不同的伺服器上可能找到具有相同帳號的使用者。",
  "dropdown.empty": "請選擇一個選項",
  "email_subscriptions.email": "電子郵件",
  "email_subscriptions.form.action": "訂閱",
  "email_subscriptions.form.bottom": "於不建立 Mastodon 帳號的情況下，將透過電子郵件取得嘟文。您可以任何時候取消訂閱。欲了解更多資訊，請參考<a>隱私權政策</a>。",
  "email_subscriptions.form.title": "訂閱 {name} 之電子郵件通訊",
  "email_subscriptions.submitted.lead": "請檢查您的收件夾以完成訂閱電子郵件通訊。",
  "email_subscriptions.submitted.title": "最後一步",
  "email_subscriptions.validation.email.blocked": "已封鎖之電子郵件提供商",
  "email_subscriptions.validation.email.invalid": "無效的電子郵件地址",
  "embed.instructions": "請複製以下程式碼以於您的網站嵌入此嘟文。",
  "embed.preview": "它將顯示成這樣：",
  "emoji_button.activity": "活動",
  "emoji_button.clear": "清除",
  "emoji_button.custom": "自訂",
  "emoji_button.flags": "旗幟",
  "emoji_button.food": "食物 & 飲料",
  "emoji_button.label": "插入 emoji 表情符號",
  "emoji_button.nature": "自然",
  "emoji_button.not_found": "啊就沒這表情符號吼！！ (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "物件",
  "emoji_button.people": "人物",
  "emoji_button.recent": "最常使用",
  "emoji_button.search": "搜尋...",
  "emoji_button.search_results": "搜尋結果",
  "emoji_button.symbols": "符號",
  "emoji_button.travel": "旅遊與地點",
  "empty_column.account_featured.other": "{acct} 尚未有任何精選內容。",
  "empty_column.account_featured_self.no_collections_button": "建立收藏名單",
  "empty_column.account_featured_self.no_collections_hide_tab": "改為隱藏此分頁",
  "empty_column.account_featured_self.pre_collections": "敬請期待收藏名單",
  "empty_column.account_featured_self.pre_collections_desc": "收藏名單功能（將於 Mastodon 4.6 上線）允許您建立自己的精選帳號名單並推薦予其他人。",
  "empty_column.account_featured_self.showcase_accounts": "展示您最喜歡的帳號",
  "empty_column.account_featured_self.showcase_accounts_desc": "收藏名單為幫助其他人探索 Fediverse 之精選帳號名單。",
  "empty_column.account_featured_unknown.other": "此帳號尚未有任何精選內容。",
  "empty_column.account_hides_collections": "這位使用者選擇不提供此資訊",
  "empty_column.account_suspended": "帳號已被停權",
  "empty_column.account_timeline": "這裡還沒有嘟文！",
  "empty_column.account_unavailable": "無法取得個人檔案",
  "empty_column.blocks": "您尚未封鎖任何使用者。",
  "empty_column.bookmarked_statuses": "您還沒有新增任何書籤。當您新增書籤時，它將於此顯示。",
  "empty_column.collections.featured_in": "您尚未被加入至任何收藏名單。",
  "empty_column.community": "本站時間軸是空的。快公開嘟些文搶頭香啊！",
  "empty_column.direct": "您還沒有收到任何私訊。當您私訊別人或收到私訊時，它將於此顯示。",
  "empty_column.disabled_feed": "此內容已被您的伺服器管理員停用。",
  "empty_column.domain_blocks": "尚未封鎖任何網域。",
  "empty_column.explore_statuses": "目前沒有熱門討論，請稍候再回來看看！",
  "empty_column.favourited_statuses": "您還沒有加過任何嘟文至最愛。當您收藏嘟文時，它將於此顯示。",
  "empty_column.favourites": "還沒有人加過這則嘟文至最愛。當有人收藏嘟文時，它們將於此顯示。",
  "empty_column.follow_requests": "您還沒有收到任何跟隨請求。當您收到的跟隨請求時，它將於此顯示。",
  "empty_column.followed_tags": "您還沒有跟隨任何主題標籤。當您跟隨主題標籤時，它們將於此顯示。",
  "empty_column.hashtag": "這個主題標籤下什麼也沒有。",
  "empty_column.home": "您的首頁時間軸是空的！跟隨更多人將它填滿吧！",
  "empty_column.list": "這份列表下什麼也沒有。當此列表的成員嘟出新的嘟文時，它們將顯示於此。",
  "empty_column.mutes": "您還沒有靜音任何使用者。",
  "empty_column.notification_requests": "清空啦！已經沒有任何推播通知。當您收到新推播通知時，它們將依照您的設定於此顯示。",
  "empty_column.notifications": "您還沒有收到任何推播通知，當您與別人開始互動時，它將於此顯示。",
  "empty_column.public": "這裡什麼都沒有！嘗試寫些公開的嘟文，或著自己跟隨其他伺服器的使用者後就會有嘟文出現了",
  "empty_state.no_results": "沒有結果",
  "error.no_hashtag_feed_access": "加入或登入 Mastodon 以檢視與跟隨此主題標籤。",
  "error.unexpected_crash.explanation": "由於發生系統故障或瀏覽器相容性問題，無法正常顯示此頁面。",
  "error.unexpected_crash.explanation_addons": "此頁面無法被正常顯示，這可能是由瀏覽器附加元件或網頁自動翻譯工具造成的。",
  "error.unexpected_crash.next_steps": "請嘗試重新整理頁面。如果狀況沒有改善，您可以透過不同的瀏覽器或應用程式以使用 Mastodon。",
  "error.unexpected_crash.next_steps_addons": "請嘗試關閉它們然後重新整理頁面。如果狀況沒有改善，您可以透過不同的瀏覽器或應用程式以使用 Mastodon。",
  "errors.unexpected_crash.copy_stacktrace": "複製 stacktrace 至剪貼簿",
  "errors.unexpected_crash.report_issue": "回報問題",
  "explore.suggested_follows": "使用者",
  "explore.title": "熱門",
  "explore.trending_links": "最新消息",
  "explore.trending_statuses": "嘟文",
  "explore.trending_tags": "主題標籤",
  "featured_carousel.current": "<sr>嘟文</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {# 則釘選嘟文}}",
  "featured_carousel.slide": "{max, number} 則嘟文中之第 {current, number} 則",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "最近您曾發過有關 {items} 之嘟文。是否新增其為推薦主題標籤？",
  "featured_tags.suggestions.add": "新增",
  "featured_tags.suggestions.added": "於 <link>編輯個人檔案 > 推薦主題標籤</link> 隨時管理您的推薦主題標籤。",
  "featured_tags.suggestions.dismiss": "不需要，謝謝",
  "filter_modal.added.context_mismatch_explanation": "此過濾器類別不是用您所存取嘟文的情境。若您想要此嘟文被於此情境被過濾，您必須編輯過濾器。",
  "filter_modal.added.context_mismatch_title": "不符合情境！",
  "filter_modal.added.expired_explanation": "此過濾器類別已失效，您需要更新過期日期以套用。",
  "filter_modal.added.expired_title": "過期的過濾器！",
  "filter_modal.added.review_and_configure": "如欲檢視與進一步設定此過濾器類別，請至 {settings_link}。",
  "filter_modal.added.review_and_configure_title": "過濾器設定",
  "filter_modal.added.settings_link": "設定頁面",
  "filter_modal.added.short_explanation": "此嘟文已被新增至以下過濾器類別：{title}。",
  "filter_modal.added.title": "已新增過濾器！",
  "filter_modal.select_filter.context_mismatch": "不適用目前情境",
  "filter_modal.select_filter.expired": "已過期",
  "filter_modal.select_filter.prompt_new": "新類別：{name}",
  "filter_modal.select_filter.search": "搜尋或新增",
  "filter_modal.select_filter.subtitle": "使用既有的類別或是新增",
  "filter_modal.select_filter.title": "過濾此嘟文",
  "filter_modal.title.status": "過濾一則嘟文",
  "filter_warning.matches_filter": "符合過濾器「<span>{title}</span>」",
  "filtered_notifications_banner.pending_requests": "來自您可能認識的 {count, plural, =0 {0 人} other {# 人}}",
  "filtered_notifications_banner.title": "已過濾之推播通知",
  "firehose.all": "全部",
  "firehose.local": "本站",
  "firehose.remote": "聯邦宇宙",
  "follow_request.authorize": "授權",
  "follow_request.reject": "拒絕",
  "follow_requests.unlocked_explanation": "即便您的帳號未被鎖定，{domain} 的管理員認為您可能想要自己審核這些帳號的跟隨請求。",
  "follow_suggestions.curated_suggestion": "精選內容",
  "follow_suggestions.dismiss": "不再顯示",
  "follow_suggestions.featured_longer": "{domain} 團隊精心挑選",
  "follow_suggestions.friends_of_friends_longer": "受您跟隨之使用者愛戴的風雲人物",
  "follow_suggestions.hints.featured": "此個人檔案是 {domain} 管理團隊精心挑選。",
  "follow_suggestions.hints.friends_of_friends": "此個人檔案於您跟隨的帳號中很受歡迎。",
  "follow_suggestions.hints.most_followed": "此個人檔案是 {domain} 中最受歡迎的帳號之一。",
  "follow_suggestions.hints.most_interactions": "此個人檔案最近於 {domain} 受到非常多關注。",
  "follow_suggestions.hints.similar_to_recently_followed": "此個人檔案與您最近跟隨之帳號類似。",
  "follow_suggestions.personalized_suggestion": "個人化推薦",
  "follow_suggestions.popular_suggestion": "熱門推薦",
  "follow_suggestions.popular_suggestion_longer": "{domain} 上的人氣王",
  "follow_suggestions.similar_to_recently_followed_longer": "與您近日跟隨相近之帳號",
  "follow_suggestions.view_all": "檢視全部",
  "follow_suggestions.who_to_follow": "推薦跟隨帳號",
  "followed_tags": "已跟隨主題標籤",
  "followers.hide_other_followers": "此使用者選擇不公開跟隨者",
  "followers.title": "正在跟隨 {name}",
  "following.hide_other_following": "此使用者選擇不公開跟隨中",
  "following.title": "被 {name} 跟隨",
  "footer.about": "關於",
  "footer.about_mastodon": "關於 Mastodon",
  "footer.about_server": "關於 {domain}",
  "footer.about_this_server": "關於",
  "footer.directory": "個人檔案目錄",
  "footer.get_app": "取得應用程式",
  "footer.keyboard_shortcuts": "鍵盤快速鍵",
  "footer.privacy_policy": "隱私權政策",
  "footer.source_code": "檢視原始碼",
  "footer.status": "狀態",
  "footer.terms_of_service": "服務條款",
  "form_error.blank": "欄位內容無法為空白。",
  "form_field.optional": "（非必填）",
  "generic.saved": "已儲存",
  "getting_started.heading": "開始使用",
  "hashtag.admin_moderation": "開啟 #{name} 之管理介面",
  "hashtag.browse": "瀏覽 #{hashtag} 之嘟文",
  "hashtag.browse_from_account": "瀏覽來自 @{name} 於 #{hashtag} 之嘟文",
  "hashtag.column_header.tag_mode.all": "以及 {additional}",
  "hashtag.column_header.tag_mode.any": "或是 {additional}",
  "hashtag.column_header.tag_mode.none": "而無需 {additional}",
  "hashtag.column_settings.select.no_options_message": "找不到建議",
  "hashtag.column_settings.select.placeholder": "請輸入主題標籤…",
  "hashtag.column_settings.tag_mode.all": "全部",
  "hashtag.column_settings.tag_mode.any": "任一",
  "hashtag.column_settings.tag_mode.none": "全不",
  "hashtag.column_settings.tag_toggle": "將額外標籤加入至此欄位",
  "hashtag.counter_by_accounts": "{count, plural, other {{counter} 名參與者}}",
  "hashtag.counter_by_uses": "{count, plural, other {{counter} 則嘟文}}",
  "hashtag.counter_by_uses_today": "本日有 {count, plural, other {{counter} 則嘟文}}",
  "hashtag.feature": "於個人檔案推薦",
  "hashtag.follow": "跟隨主題標籤",
  "hashtag.mute": "靜音 #{hashtag}",
  "hashtag.unfeature": "取消於個人檔案推薦",
  "hashtag.unfollow": "取消跟隨主題標籤",
  "hashtags.and_other": "…及其他 {count, plural, other {# 個}}",
  "hints.profiles.followers_may_be_missing": "此個人檔案之跟隨者或有缺失。",
  "hints.profiles.follows_may_be_missing": "此個人檔案之正在跟隨或有缺失。",
  "hints.profiles.posts_may_be_missing": "此個人檔案之某些嘟文或有缺失。",
  "hints.profiles.see_more_followers": "於 {domain} 檢視更多跟隨者",
  "hints.profiles.see_more_follows": "於 {domain} 檢視更多正在跟隨",
  "hints.profiles.see_more_posts": "於 {domain} 檢視更多嘟文",
  "home.column_settings.show_quotes": "顯示引用嘟文",
  "home.column_settings.show_reblogs": "顯示轉嘟",
  "home.column_settings.show_replies": "顯示回嘟",
  "home.hide_announcements": "隱藏公告",
  "home.pending_critical_update.body": "請立即升級您的 Mastodon 伺服器！",
  "home.pending_critical_update.link": "檢視更新內容",
  "home.pending_critical_update.title": "有可取得的重要安全性更新！",
  "home.show_announcements": "顯示公告",
  "ignore_notifications_modal.disclaimer": "Mastodon 無法通知您已忽略推播通知之使用者。忽略通知不會阻止訊息本身的發送。",
  "ignore_notifications_modal.filter_instead": "改為過濾",
  "ignore_notifications_modal.filter_to_act_users": "您仍能接受、拒絕、或檢舉使用者",
  "ignore_notifications_modal.filter_to_avoid_confusion": "過濾器有助於避免潛在的混淆",
  "ignore_notifications_modal.filter_to_review_separately": "您能單獨檢視已過濾推播通知",
  "ignore_notifications_modal.ignore": "忽略推播通知",
  "ignore_notifications_modal.limited_accounts_title": "是否忽略來自受管制帳號之推播通知？",
  "ignore_notifications_modal.new_accounts_title": "是否忽略來自新帳號之推播通知？",
  "ignore_notifications_modal.not_followers_title": "是否忽略來自未跟隨您帳號之推播通知？",
  "ignore_notifications_modal.not_following_title": "是否忽略來自您未跟隨帳號之推播通知？",
  "ignore_notifications_modal.private_mentions_title": "是否忽略來自不請自來私訊之推播通知？",
  "info_button.label": "幫助",
  "info_button.what_is_alt_text": "<h1>何謂 ALT 說明文字？</h1> <p>ALT 說明文字為視覺障礙者、低網路頻寬或尋求額外上下文語境的人們提供圖片描述。</p> <p>您可以透過撰寫清晰、簡潔及客觀的說明文字以替所有人改善無障礙特性與協助理解。</p> <ul> <li>掌握幾個重要元素</li> <li>替圖片提供文字摘要</li> <li>使用常規行文結構</li> <li>避免冗贅資訊</li> <li>聚焦於趨勢與複雜視覺中之關鍵（如圖表或地圖）</li> </ul>",
  "interaction_modal.action": "若欲與 {name} 之嘟文互動，您必須登入您帳號所註冊之 Mastodon 伺服器。",
  "interaction_modal.action_follow": "若欲跟隨 {name}，您必須登入您帳號所註冊之 Mastodon 伺服器。",
  "interaction_modal.go": "Go！",
  "interaction_modal.no_account_yet": "仍尚未擁有帳號嗎？",
  "interaction_modal.on_another_server": "於不同伺服器",
  "interaction_modal.on_this_server": "於此伺服器",
  "interaction_modal.title": "請先登入以繼續",
  "interaction_modal.username_prompt": "例如 {example}",
  "intervals.full.days": "{number, plural, other {# 天}}",
  "intervals.full.hours": "{number, plural, other {# 小時}}",
  "intervals.full.minutes": "{number, plural, other {# 分鐘}}",
  "keyboard_shortcuts.back": "上一頁",
  "keyboard_shortcuts.blocked": "開啟「封鎖使用者」列表",
  "keyboard_shortcuts.boost": "轉嘟",
  "keyboard_shortcuts.column": "將游標移至其中一欄",
  "keyboard_shortcuts.compose": "將游標移至文字撰寫區塊",
  "keyboard_shortcuts.description": "說明",
  "keyboard_shortcuts.direct": "開啟私訊對話欄",
  "keyboard_shortcuts.down": "向下移動",
  "keyboard_shortcuts.enter": "開啟嘟文",
  "keyboard_shortcuts.explore": "開啟熱門趨勢時間軸",
  "keyboard_shortcuts.favourite": "加至最愛",
  "keyboard_shortcuts.favourites": "開啟最愛列表",
  "keyboard_shortcuts.federated": "開啟聯邦時間軸",
  "keyboard_shortcuts.heading": "鍵盤快速鍵",
  "keyboard_shortcuts.home": "開啟首頁時間軸",
  "keyboard_shortcuts.hotkey": "快速鍵",
  "keyboard_shortcuts.legend": "顯示此說明選單",
  "keyboard_shortcuts.load_more": "將焦點移至「讀取更多」按鈕",
  "keyboard_shortcuts.local": "開啟本站時間軸",
  "keyboard_shortcuts.mention": "提及作者",
  "keyboard_shortcuts.muted": "開啟靜音使用者列表",
  "keyboard_shortcuts.my_profile": "開啟個人檔案頁面",
  "keyboard_shortcuts.notifications": "開啟通知欄",
  "keyboard_shortcuts.open_media": "開啟媒體",
  "keyboard_shortcuts.pinned": "開啟釘選的嘟文列表",
  "keyboard_shortcuts.profile": "開啟作者的個人檔案頁面",
  "keyboard_shortcuts.quote": "引用嘟文",
  "keyboard_shortcuts.reply": "回覆嘟文",
  "keyboard_shortcuts.requests": "開啟跟隨請求列表",
  "keyboard_shortcuts.search": "將游標移至搜尋框",
  "keyboard_shortcuts.spoilers": "顯示或隱藏內容警告之嘟文",
  "keyboard_shortcuts.start": "開啟「開始使用」欄位",
  "keyboard_shortcuts.toggle_hidden": "顯示或隱藏於內容警告之後的嘟文",
  "keyboard_shortcuts.toggle_sensitivity": "顯示或隱藏媒體",
  "keyboard_shortcuts.toot": "發表新嘟文",
  "keyboard_shortcuts.top": "移至列表最上方",
  "keyboard_shortcuts.translate": "翻譯嘟文",
  "keyboard_shortcuts.unfocus": "跳離文字撰寫區塊或搜尋框",
  "keyboard_shortcuts.up": "向上移動",
  "learn_more_link.got_it": "了解",
  "learn_more_link.learn_more": "了解更多",
  "lightbox.close": "關閉",
  "lightbox.next": "下一步",
  "lightbox.previous": "上一步",
  "lightbox.zoom_in": "縮放至實際大小",
  "lightbox.zoom_out": "縮放至合適大小",
  "limited_account_hint.action": "一律顯示個人檔案",
  "limited_account_hint.title": "此個人檔案已被 {domain} 之管理員隱藏。",
  "link_preview.author": "來自 {name}",
  "link_preview.more_from_author": "來自 {name} 之更多內容",
  "link_preview.shares": "{count, plural, other {{counter} 則嘟文}}",
  "lists.add_member": "新增",
  "lists.add_to_list": "新增至列表",
  "lists.add_to_lists": "新增 {name} 至列表",
  "lists.create": "建立",
  "lists.create_a_list_to_organize": "建立新列表以整理您的首頁時間軸",
  "lists.create_list": "建立列表",
  "lists.delete": "刪除列表",
  "lists.done": "完成",
  "lists.edit": "編輯列表",
  "lists.exclusive": "於首頁隱藏列表成員",
  "lists.exclusive_hint": "如果某個帳號於此列表中，將自您的首頁時間軸中隱藏此帳號，以防重複見到他們的嘟文。",
  "lists.find_users_to_add": "尋找欲新增之使用者",
  "lists.list_members_count": "{count, plural, other {# 個成員}}",
  "lists.list_name": "列表名稱",
  "lists.new_list_name": "新列表名稱",
  "lists.no_lists_yet": "尚無列表。",
  "lists.no_members_yet": "尚無成員。",
  "lists.no_results_found": "找不到結果。",
  "lists.remove_member": "移除",
  "lists.replies_policy.followed": "任何已跟隨之使用者",
  "lists.replies_policy.list": "列表成員",
  "lists.replies_policy.none": "沒有人",
  "lists.save": "儲存",
  "lists.search": "搜尋",
  "lists.show_replies_to": "包含來自列表成員的回覆至",
  "load_pending": "{count, plural, other {# 個新項目}}",
  "loading_indicator.label": "正在載入...",
  "media_gallery.hide": "隱藏",
  "moved_to_account_banner.text": "您的帳號 {disabledAccount} 目前已停用，因為您已搬家至 {movedToAccount}。",
  "mute_modal.hide_from_notifications": "於推播通知中隱藏",
  "mute_modal.hide_options": "隱藏選項",
  "mute_modal.indefinite": "直到我解除靜音",
  "mute_modal.show_options": "顯示選項",
  "mute_modal.they_can_mention_and_follow": "他們仍可提及或跟隨您，但您不會見到他們。",
  "mute_modal.they_wont_know": "他們不會知道他們已被靜音。",
  "mute_modal.title": "是否靜音該使用者？",
  "mute_modal.you_wont_see_mentions": "您將不會見到提及他們的嘟文。",
  "mute_modal.you_wont_see_posts": "他們仍可讀取您的嘟文，但您不會見到他們的嘟文。",
  "navigation_bar.about": "關於",
  "navigation_bar.account_settings": "密碼與安全性",
  "navigation_bar.administration": "管理介面",
  "navigation_bar.advanced_interface": "以進階網頁介面開啟",
  "navigation_bar.automated_deletion": "自動嘟文刪除",
  "navigation_bar.blocks": "已封鎖使用者",
  "navigation_bar.bookmarks": "書籤",
  "navigation_bar.collections": "收藏名單",
  "navigation_bar.direct": "私訊",
  "navigation_bar.domain_blocks": "已封鎖網域",
  "navigation_bar.favourites": "最愛",
  "navigation_bar.filters": "已靜音的關鍵字",
  "navigation_bar.follow_requests": "跟隨請求",
  "navigation_bar.followed_tags": "主題標籤",
  "navigation_bar.follows_and_followers": "跟隨中與跟隨者",
  "navigation_bar.import_export": "匯入及匯出",
  "navigation_bar.lists": "列表",
  "navigation_bar.live_feed_local": "即時內容（本站）",
  "navigation_bar.live_feed_public": "即時內容（公開）",
  "navigation_bar.logout": "登出",
  "navigation_bar.moderation": "站務",
  "navigation_bar.more": "更多",
  "navigation_bar.mutes": "已靜音的使用者",
  "navigation_bar.opened_in_classic_interface": "預設於經典網頁介面中開啟嘟文、帳號與其他特定頁面。",
  "navigation_bar.preferences": "偏好設定",
  "navigation_bar.privacy_and_reach": "隱私權與觸及",
  "navigation_bar.search": "搜尋",
  "navigation_bar.search_trends": "搜尋 / 熱門趨勢",
  "navigation_panel.collapse_followed_tags": "收合已跟隨主題標籤選單",
  "navigation_panel.collapse_lists": "收合列表選單",
  "navigation_panel.expand_followed_tags": "展開已跟隨主題標籤選單",
  "navigation_panel.expand_lists": "展開列表選單",
  "not_signed_in_indicator.not_signed_in": "您需要登入才能存取此資源。",
  "notification.added_to_collection": "{name} 將您加入至收藏名單",
  "notification.admin.report": "{name} 已檢舉 {target}",
  "notification.admin.report_account": "{name} 已檢舉來自 {target} 關於 {category} 之 {count, plural, other {# 則嘟文}}",
  "notification.admin.report_account_other": "{name} 已檢舉來自 {target} 之 {count, plural, other {# 則嘟文}}",
  "notification.admin.report_statuses": "{name} 已檢舉 {target} 關於 {category}",
  "notification.admin.report_statuses_other": "{name} 已檢舉 {target}",
  "notification.admin.sign_up": "{name} 已經註冊",
  "notification.admin.sign_up.name_and_others": "{name} 與{count, plural, other {其他 # 個人}}已註冊",
  "notification.annual_report.message": "您的 {year} #Wrapstodon 正等著您！揭開您 Mastodon 上的年度精彩時刻與值得回憶的難忘時光！",
  "notification.annual_report.view": "檢視 #Wrapstodon 年度回顧",
  "notification.collection_update": "{name} 已編輯您所在之收藏名單",
  "notification.favourite": "{name} 已將您的嘟文加入最愛",
  "notification.favourite.name_and_others_with_link": "{name} 與<a>{count, plural, other {其他 # 個人}}</a>已將您的嘟文加入最愛",
  "notification.favourite_pm": "{name} 將您的私訊加入最愛",
  "notification.favourite_pm.name_and_others_with_link": "{name} 與<a>{count, plural, other {其他 # 個人}}</a>已將您的私訊加入最愛",
  "notification.follow": "{name} 已跟隨您",
  "notification.follow.name_and_others": "{name} 與<a>{count, plural, other {其他 # 個人}}</a>已跟隨您",
  "notification.follow_request": "{name} 要求跟隨您",
  "notification.follow_request.name_and_others": "{name} 與{count, plural, other {其他 # 個人}}已請求跟隨您",
  "notification.label.mention": "提及",
  "notification.label.private_mention": "私訊",
  "notification.label.private_reply": "私訊回嘟",
  "notification.label.quote": "{name} 已引用您的嘟文",
  "notification.label.reply": "回嘟",
  "notification.mention": "提及",
  "notification.mentioned_you": "{name} 已提及您",
  "notification.moderation-warning.learn_more": "了解更多",
  "notification.moderation_warning": "您已收到管理員警告",
  "notification.moderation_warning.action_delete_statuses": "某些您的嘟文已被刪除。",
  "notification.moderation_warning.action_disable": "您的帳號已被停用。",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "某些您的嘟文已被標記為敏感內容。",
  "notification.moderation_warning.action_none": "您的帳號已收到管理員警告。",
  "notification.moderation_warning.action_sensitive": "即日起，您的嘟文將被標記為敏感內容。",
  "notification.moderation_warning.action_silence": "您的帳號已被限制。",
  "notification.moderation_warning.action_suspend": "您的帳號已被停權。",
  "notification.own_poll": "您的投票已結束",
  "notification.poll": "您曾投過的投票已經結束",
  "notification.quoted_update": "{name} 已編輯一則您曾引用之嘟文",
  "notification.reblog": "{name} 已轉嘟您的嘟文",
  "notification.reblog.name_and_others_with_link": "{name} 與<a>{count, plural, other {其他 # 個人}}</a>已轉嘟您的嘟文",
  "notification.relationships_severance_event": "與 {name} 失去連結",
  "notification.relationships_severance_event.account_suspension": "{from} 之管理員已將 {target} 停權，意味著您將不再收到來自他們的更新或與之互動。",
  "notification.relationships_severance_event.domain_block": "{from} 之管理員已將 {target} 封鎖，包含 {followersCount} 名您的跟隨者及 {followingCount, plural, other {#}} 名您跟隨的帳號。",
  "notification.relationships_severance_event.learn_more": "了解更多",
  "notification.relationships_severance_event.user_domain_block": "您已將 {target} 封鎖，將移除 {followersCount} 名您的跟隨者及 {followingCount, plural, other {#}} 名您跟隨的帳號。",
  "notification.status": "{name} 剛剛嘟文",
  "notification.update": "{name} 已編輯嘟文",
  "notification_requests.accept": "接受",
  "notification_requests.accept_multiple": "{count, plural, other {接受 # 則請求...}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {接受請求}}",
  "notification_requests.confirm_accept_multiple.message": "您將接受 {count, plural, other {# 則推播通知請求}}。您確定要繼續嗎？",
  "notification_requests.confirm_accept_multiple.title": "是否接受推播通知請求？",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {忽略請求}}",
  "notification_requests.confirm_dismiss_multiple.message": "您將忽略 {count, plural, other {# 則推播通知請求}}。您將不再能輕易存取{count, plural, other {這些}}推播通知。您確定要繼續嗎？",
  "notification_requests.confirm_dismiss_multiple.title": "是否忽略推播通知請求？",
  "notification_requests.dismiss": "關閉",
  "notification_requests.dismiss_multiple": "{count, plural, other {忽略 # 則請求...}}",
  "notification_requests.edit_selection": "編輯",
  "notification_requests.exit_selection": "完成",
  "notification_requests.explainer_for_limited_account": "由於此帳號已被管理員限制，來自此帳號之通知已被過濾。",
  "notification_requests.explainer_for_limited_remote_account": "由於此帳號或其伺服器已被管理員限制，來自此帳號之通知已被過濾。",
  "notification_requests.maximize": "最大化",
  "notification_requests.minimize_banner": "最小化已過濾通知橫幅",
  "notification_requests.notifications_from": "來自 {name} 之通知",
  "notification_requests.title": "已過濾之推播通知",
  "notification_requests.view": "檢視推播通知",
  "notifications.clear": "清除通知",
  "notifications.clear_confirmation": "您確定要永久清除您的通知嗎？",
  "notifications.clear_title": "是否清除推播通知？",
  "notifications.column_settings.admin.report": "新檢舉報告：",
  "notifications.column_settings.admin.sign_up": "新註冊帳號：",
  "notifications.column_settings.alert": "桌面通知",
  "notifications.column_settings.favourite": "最愛：",
  "notifications.column_settings.filter_bar.advanced": "顯示所有分類",
  "notifications.column_settings.filter_bar.category": "快速過濾器",
  "notifications.column_settings.follow": "新的跟隨者：",
  "notifications.column_settings.follow_request": "新的跟隨請求：",
  "notifications.column_settings.group": "群組",
  "notifications.column_settings.mention": "提及：",
  "notifications.column_settings.poll": "投票結果：",
  "notifications.column_settings.push": "推播通知",
  "notifications.column_settings.quote": "引用嘟文：",
  "notifications.column_settings.reblog": "轉嘟：",
  "notifications.column_settings.show": "於欄位中顯示",
  "notifications.column_settings.sound": "播放音效",
  "notifications.column_settings.status": "新嘟文：",
  "notifications.column_settings.unread_notifications.category": "未讀通知",
  "notifications.column_settings.unread_notifications.highlight": "突顯未讀通知",
  "notifications.column_settings.update": "編輯：",
  "notifications.filter.all": "全部",
  "notifications.filter.boosts": "轉嘟",
  "notifications.filter.favourites": "最愛",
  "notifications.filter.follows": "跟隨的使用者",
  "notifications.filter.mentions": "提及",
  "notifications.filter.polls": "投票結果",
  "notifications.filter.statuses": "您跟隨的使用者之最新動態",
  "notifications.grant_permission": "授予權限",
  "notifications.group": "{count} 條通知",
  "notifications.mark_as_read": "將所有通知都標記為已讀",
  "notifications.permission_denied": "由於之前已拒絕瀏覽器請求，因此無法使用桌面通知",
  "notifications.permission_denied_alert": "由於之前瀏覽器權限被拒絕，無法啟用桌面通知",
  "notifications.permission_required": "由於尚未授予所需的權限，因此無法使用桌面通知。",
  "notifications.policy.accept": "接受",
  "notifications.policy.accept_hint": "顯示於推播通知",
  "notifications.policy.drop": "忽略",
  "notifications.policy.drop_hint": "送至黑洞，永不相見",
  "notifications.policy.filter": "過濾器",
  "notifications.policy.filter_hint": "送至已過濾推播通知收件夾",
  "notifications.policy.filter_limited_accounts_hint": "已被伺服器管理員限制",
  "notifications.policy.filter_limited_accounts_title": "受管制帳號",
  "notifications.policy.filter_new_accounts.hint": "新增於過去 {days, plural, other {# 日}}",
  "notifications.policy.filter_new_accounts_title": "新帳號",
  "notifications.policy.filter_not_followers_hint": "包含最近 {days, plural, other {# 日}}內跟隨您之使用者",
  "notifications.policy.filter_not_followers_title": "未跟隨您之使用者",
  "notifications.policy.filter_not_following_hint": "直至您手動核准他們",
  "notifications.policy.filter_not_following_title": "您未跟隨之使用者",
  "notifications.policy.filter_private_mentions_hint": "過濾通知，除非嘟文包含於您的提及，或您跟隨該發嘟帳號",
  "notifications.policy.filter_private_mentions_title": "不請自來的私訊",
  "notifications.policy.title": "管理推播通知來自...",
  "notifications_permission_banner.enable": "啟用桌面通知",
  "notifications_permission_banner.how_to_control": "啟用桌面通知以於 Mastodon 沒有開啟的時候接收通知。啟用桌面通知後，您可以透過上面的 {icon} 按鈕準確的控制哪些類型的互動會產生桌面通知。",
  "notifications_permission_banner.title": "不要錯過任何東西！",
  "onboarding.follows.back": "返回",
  "onboarding.follows.empty": "很遺憾，目前未能顯示任何結果。您可以嘗試使用搜尋、瀏覽探索頁面以找尋人們跟隨、或稍候再試。",
  "onboarding.follows.next": "下一步：設定您的個人檔案",
  "onboarding.follows.search": "搜尋",
  "onboarding.follows.title": "開始跟隨一些人吧",
  "onboarding.profile.discoverable": "使我的個人檔案可以被找到",
  "onboarding.profile.discoverable_hint": "當您於 Mastodon 上選擇加入可發現性時，您的嘟文可能會顯示於搜尋結果與趨勢中。您的個人檔案可能會被推薦至與您志趣相投的人。",
  "onboarding.profile.display_name": "顯示名稱",
  "onboarding.profile.display_name_hint": "完整名稱或暱稱...",
  "onboarding.profile.finish": "完成",
  "onboarding.profile.note": "個人簡介",
  "onboarding.profile.note_hint": "您可以 @mention 其他人或者使用 #主題標籤...",
  "onboarding.profile.title": "個人檔案設定",
  "onboarding.profile.upload_avatar": "上傳個人檔案大頭貼",
  "onboarding.profile.upload_header": "上傳個人檔案封面圖片",
  "password_confirmation.exceeds_maxlength": "密碼驗證欄超過最長密碼長度限制",
  "password_confirmation.mismatching": "密碼驗證欄與密碼不一致",
  "picture_in_picture.restore": "還原",
  "poll.closed": "已關閉",
  "poll.refresh": "重新整理",
  "poll.reveal": "檢視結果",
  "poll.total_people": "{count, plural, other {# 個人}}",
  "poll.total_votes": "{count, plural, other {# 張票}}",
  "poll.vote": "投票",
  "poll.voted": "您已對此問題投票",
  "poll.votes": "{votes, plural, other {# 張票}}",
  "poll_button.add_poll": "新增投票",
  "poll_button.remove_poll": "移除投票",
  "privacy.change": "調整嘟文隱私狀態",
  "privacy.direct.long": "此嘟文提及之所有人",
  "privacy.direct.short": "私訊",
  "privacy.private.long": "只有跟隨您之使用者能看到",
  "privacy.private.short": "跟隨者",
  "privacy.public.long": "所有人 (無論在 Mastodon 上與否)",
  "privacy.public.short": "公開",
  "privacy.quote.anyone": "{visibility}，允許引用嘟文",
  "privacy.quote.disabled": "{visibility}，停用引用嘟文",
  "privacy.quote.limited": "{visibility}，受限的引用嘟文",
  "privacy.unlisted.additional": "此與公開嘟文完全相同，但嘟文不會出現於即時內容或主題標籤、探索、及 Mastodon 搜尋中，即使您於帳戶設定中選擇加入。",
  "privacy.unlisted.long": "不顯示於 Mastodon 之搜尋結果、熱門趨勢、及公開時間軸上",
  "privacy.unlisted.short": "不公開",
  "privacy_policy.last_updated": "最後更新：{date}",
  "privacy_policy.title": "隱私權政策",
  "quote_error.edit": "編輯嘟文時無法新增引用嘟文。",
  "quote_error.poll": "無法引用投票嘟文。",
  "quote_error.private_mentions": "無法引用私訊嘟文。",
  "quote_error.quote": "一次僅能引用一則嘟文。",
  "quote_error.unauthorized": "您不被授權允許引用此嘟文。",
  "quote_error.upload": "無法引用含有多媒體附加檔案之嘟文。",
  "recommended": "推薦設定",
  "refresh": "重新整理",
  "regeneration_indicator.please_stand_by": "請稍候。",
  "regeneration_indicator.preparing_your_home_feed": "正在準備您的首頁時間軸...",
  "relative_time.days": "{number} 天",
  "relative_time.full.days": "{number, plural, other {# 天}}前",
  "relative_time.full.hours": "{number, plural, other {# 小時}}前",
  "relative_time.full.just_now": "剛剛",
  "relative_time.full.minutes": "{number, plural, other {# 分鐘}}前",
  "relative_time.full.seconds": "{number, plural, other {# 秒}}前",
  "relative_time.hours": "{number} 小時前",
  "relative_time.just_now": "剛剛",
  "relative_time.minutes": "{number} 分鐘前",
  "relative_time.seconds": "{number} 秒",
  "relative_time.today": "今天",
  "remove_quote_hint.button_label": "了解",
  "remove_quote_hint.message": "您能自 {icon} 選單完成此操作。",
  "remove_quote_hint.title": "是否想要移除您的引用嘟文？",
  "reply_indicator.attachments": "{count, plural, other {# 個附加檔案}}",
  "reply_indicator.cancel": "取消",
  "reply_indicator.poll": "投票",
  "report.block": "封鎖",
  "report.block_explanation": "您將不再看到他們的嘟文。他們將無法檢視您的嘟文或是跟隨您。他們會發現他們已被封鎖。",
  "report.categories.legal": "合法性",
  "report.categories.other": "其他",
  "report.categories.spam": "垃圾訊息",
  "report.categories.violation": "內容違反一項或多項伺服器條款",
  "report.category.subtitle": "選擇最佳條件符合",
  "report.category.title": "告訴我們這個 {type} 發生了什麼事",
  "report.category.title_account": "個人檔案",
  "report.category.title_status": "嘟文",
  "report.close": "已完成",
  "report.collection_comment": "您檢舉此收藏名單的原因是？",
  "report.comment.title": "有什麼其他您想讓我們知道的嗎？",
  "report.forward": "轉寄到 {target}",
  "report.forward_hint": "這個帳號屬於其他伺服器。要向該伺服器發送匿名的檢舉訊息嗎？",
  "report.mute": "靜音",
  "report.mute_explanation": "您將不再看到他們的嘟文。他們仍能可以跟隨您以及檢視您的嘟文，並且不會知道他們已被靜音。",
  "report.next": "繼續",
  "report.placeholder": "其他備註",
  "report.reasons.dislike": "我不喜歡",
  "report.reasons.dislike_description": "這是您不想看到的",
  "report.reasons.legal": "這是非法事項",
  "report.reasons.legal_description": "您認為它已違反您或伺服器所在國家之法律",
  "report.reasons.other": "其他原因",
  "report.reasons.other_description": "這個問題不屬於其他分類",
  "report.reasons.spam": "垃圾訊息",
  "report.reasons.spam_description": "有害連結、假造的互動，或是重複性回覆",
  "report.reasons.violation": "違反伺服器規則",
  "report.reasons.violation_description": "您知道它違反特定規則",
  "report.rules.subtitle": "請選擇所有適用的選項",
  "report.rules.title": "違反了哪些規則？",
  "report.statuses.subtitle": "請選擇所有適用的選項",
  "report.statuses.title": "是否有能佐證這份檢舉之嘟文？",
  "report.submission_error": "無法送出檢舉",
  "report.submission_error_details": "請檢查您的網路連線並稍候重試。",
  "report.submit": "送出",
  "report.target": "檢舉 {target}",
  "report.thanks.take_action": "以下是控制您想於 Mastodon 看到什麼內容之選項：",
  "report.thanks.take_action_actionable": "當我們正在審核期間，您可以對 @{name} 採取以下措施：",
  "report.thanks.title": "不想再看到這個？",
  "report.thanks.title_actionable": "感謝您的檢舉，我們將會著手處理。",
  "report.unfollow": "取消跟隨 @{name}",
  "report.unfollow_explanation": "您正在跟隨此帳號。如不欲於首頁時間軸再見到他們的嘟文，請取消跟隨。",
  "report_notification.attached_statuses": "已附加 {count, plural, other {{count} 則嘟文}}",
  "report_notification.categories.legal": "合法性",
  "report_notification.categories.legal_sentence": "違法內容",
  "report_notification.categories.other": "其他",
  "report_notification.categories.other_sentence": "其他",
  "report_notification.categories.spam": "垃圾訊息",
  "report_notification.categories.spam_sentence": "垃圾訊息",
  "report_notification.categories.violation": "違反規則",
  "report_notification.categories.violation_sentence": "違反規則",
  "report_notification.open": "開啟檢舉報告",
  "search.clear": "清除搜尋紀錄",
  "search.no_recent_searches": "尚無最近的搜尋紀錄",
  "search.placeholder": "搜尋",
  "search.quick_action.account_search": "符合的個人檔案 {x}",
  "search.quick_action.go_to_account": "前往個人檔案 {x}",
  "search.quick_action.go_to_hashtag": "前往主題標籤 {x}",
  "search.quick_action.open_url": "於 Mastodon 中開啟連結",
  "search.quick_action.status_search": "符合的嘟文 {x}",
  "search.search_or_paste": "搜尋或輸入網址",
  "search_popout.full_text_search_disabled_message": "{domain} 上無法使用。",
  "search_popout.full_text_search_logged_out_message": "功能僅限登入後使用。",
  "search_popout.language_code": "ISO 語言代碼 (ISO language code)",
  "search_popout.options": "搜尋選項",
  "search_popout.quick_actions": "快捷操作",
  "search_popout.recent": "最近的搜尋紀錄",
  "search_popout.specific_date": "特定日期",
  "search_popout.user": "使用者",
  "search_results.accounts": "個人檔案",
  "search_results.all": "全部",
  "search_results.hashtags": "主題標籤",
  "search_results.no_results": "沒有結果。",
  "search_results.no_search_yet": "嘗試搜尋嘟文、個人檔案或主題標籤。",
  "search_results.see_all": "檢視全部",
  "search_results.statuses": "嘟文",
  "search_results.title": "搜尋「{q}」",
  "server_banner.about_active_users": "最近三十日內使用此伺服器的人（月活躍使用者）",
  "server_banner.active_users": "活躍使用者",
  "server_banner.administered_by": "管理者：",
  "server_banner.is_one_of_many": "{domain} 為許多獨立的 Mastodon 伺服器之一，您能透過該伺服器參與聯邦宇宙。",
  "server_banner.more_about_this_server": "更多關於此伺服器",
  "server_banner.server_stats": "伺服器統計：",
  "sign_in_banner.create_account": "新增帳號",
  "sign_in_banner.follow_anyone": "跟隨聯邦宇宙中的任何人，並且以時間順序瀏覽所有內容。沒有演算法、廣告、或騙點擊連結。",
  "sign_in_banner.mastodon_is": "Mastodon 是跟上時代潮流的最佳工具！",
  "sign_in_banner.sign_in": "登入",
  "sign_in_banner.sso_redirect": "登入或註冊",
  "skip_links.hotkey": "<span>快速鍵</span> {hotkey}",
  "skip_links.skip_to_content": "跳至主內容",
  "skip_links.skip_to_navigation": "跳至主導航區",
  "status.admin_account": "開啟 @{name} 的管理介面",
  "status.admin_domain": "開啟 {domain} 的管理介面",
  "status.admin_status": "於管理介面開啟此嘟文",
  "status.all_disabled": "已停用轉嘟與引用",
  "status.block": "封鎖 @{name}",
  "status.bookmark": "書籤",
  "status.cancel_reblog_private": "取消轉嘟",
  "status.cannot_quote": "您不被允許引用此嘟文",
  "status.cannot_reblog": "這則嘟文無法被轉嘟",
  "status.contains_quote": "包含引用嘟文",
  "status.context.loading": "讀取更多回嘟",
  "status.context.loading_error": "無法讀取新回嘟",
  "status.context.loading_success": "已讀取新回嘟",
  "status.context.more_replies_found": "已有更多回嘟",
  "status.context.retry": "再試一次",
  "status.context.show": "顯示",
  "status.continued_thread": "接續討論串",
  "status.copy": "複製嘟文連結",
  "status.delete": "刪除",
  "status.delete.success": "已刪除嘟文",
  "status.detailed_status": "詳細的對話內容",
  "status.direct": "私訊 @{name}",
  "status.direct_indicator": "私訊",
  "status.edit": "編輯",
  "status.edited": "上次編輯於 {date}",
  "status.edited_x_times": "已編輯 {count, plural, other {{count} 次}}",
  "status.embed": "取得嵌入程式碼",
  "status.favourite": "最愛",
  "status.favourites_count": "{count, plural, other {{counter} 則最愛}}",
  "status.filter": "過濾此嘟文",
  "status.history.created": "{name} 於 {date} 建立",
  "status.history.edited": "{name} 於 {date} 修改",
  "status.load_more": "載入更多",
  "status.media.open": "點擊以開啟",
  "status.media.show": "點擊以顯示",
  "status.media_hidden": "隱藏的媒體內容",
  "status.mention": "提及 @{name}",
  "status.more": "更多",
  "status.mute": "靜音 @{name}",
  "status.mute_conversation": "靜音對話",
  "status.open": "展開此嘟文",
  "status.pin": "釘選至個人檔案頁面",
  "status.quote": "引用",
  "status.quote.cancel": "取消引用嘟文",
  "status.quote_error.blocked_account_hint.title": "由於您已封鎖 @{name}，此嘟文已被隱藏。",
  "status.quote_error.blocked_domain_hint.title": "由於您已封鎖 {domain}，此嘟文已被隱藏。",
  "status.quote_error.filtered": "由於您的過濾器，該嘟文被隱藏",
  "status.quote_error.limited_account_hint.action": "仍要顯示",
  "status.quote_error.limited_account_hint.title": "此個人檔案已被 {domain} 的管理員隱藏。",
  "status.quote_error.muted_account_hint.title": "由於您已靜音 @{name}，此嘟文已被隱藏。",
  "status.quote_error.not_available": "無法取得該嘟文",
  "status.quote_error.pending_approval": "嘟文正在等候審核中",
  "status.quote_error.pending_approval_popout.body": "您能於 Mastodon 控制是否允許引用您的嘟文。此嘟文正在等待原始作者審核。",
  "status.quote_error.revoked": "嘟文已被作者刪除",
  "status.quote_followers_only": "只有我的跟隨者能引用此嘟文",
  "status.quote_manual_review": "嘟文作者將人工審閱",
  "status.quote_noun": "引用嘟文",
  "status.quote_policy_change": "變更可以引用的人",
  "status.quote_post_author": "已引用 @{name} 之嘟文",
  "status.quote_private": "無法引用私人嘟文",
  "status.quotes.empty": "目前尚無人引用此嘟文。當有人引用時，它將於此顯示。",
  "status.quotes.local_other_disclaimer": "被作者拒絕之引用嘟文將不被顯示。",
  "status.quotes.remote_other_disclaimer": "僅有來自 {domain} 之引用嘟文保證將於此顯示。被作者拒絕之引用嘟文將不被顯示。",
  "status.quotes_count": "{count, plural, other {{counter} 則引用嘟文}}",
  "status.read_more": "閱讀更多",
  "status.reblog": "轉嘟",
  "status.reblog_or_quote": "轉嘟或引用",
  "status.reblog_private": "再次與跟隨者分享",
  "status.reblogged_by": "{name} 已轉嘟",
  "status.reblogs.empty": "還沒有人轉嘟過這則嘟文。當有人轉嘟時，它們將於此顯示。",
  "status.reblogs_count": "{count, plural, other {{counter} 則轉嘟}}",
  "status.redraft": "刪除並重新編輯",
  "status.remove_bookmark": "自書籤中移除",
  "status.remove_favourite": "自最愛中移除",
  "status.remove_quote": "刪除",
  "status.replied_in_thread": "於討論串中回覆",
  "status.replied_to": "回覆 {name}",
  "status.reply": "回覆",
  "status.replyAll": "回覆討論串",
  "status.report": "檢舉 @{name}",
  "status.request_quote": "要求引用嘟文",
  "status.revoke_quote": "將我的嘟文自 @{name} 之嘟文中移除",
  "status.sensitive_warning": "敏感內容",
  "status.share": "分享",
  "status.show_less_all": "隱藏所有內容警告與額外標籤",
  "status.show_more_all": "顯示所有內容警告與額外標籤",
  "status.show_original": "顯示原文",
  "status.title.with_attachments": "{user} 嘟了 {attachmentCount, plural, other {{attachmentCount} 個附加檔案}}",
  "status.translate": "翻譯",
  "status.translated_from_with": "透過 {provider} 翻譯 {lang}",
  "status.uncached_media_warning": "無法預覽",
  "status.unmute_conversation": "解除此對話的靜音",
  "status.unpin": "自個人檔案頁面取消釘選",
  "subscribed_languages.lead": "僅選定語言的嘟文才會出現於您的首頁上，並於變更後列出時間軸。選取「無」以接收所有語言的嘟文。",
  "subscribed_languages.save": "儲存變更",
  "subscribed_languages.target": "變更 {target} 的訂閱語言",
  "tabs_bar.home": "首頁",
  "tabs_bar.menu": "選單",
  "tabs_bar.notifications": "通知",
  "tabs_bar.publish": "新增嘟文",
  "tabs_bar.search": "搜尋",
  "tag.remove": "移除",
  "terms_of_service.effective_as_of": "{date} 起生效",
  "terms_of_service.title": "服務條款",
  "terms_of_service.upcoming_changes_on": "{date} 起即將發生之異動",
  "time_remaining.days": "剩餘 {number, plural, other {# 天}}",
  "time_remaining.hours": "剩餘 {number, plural, other {# 小時}}",
  "time_remaining.minutes": "剩餘 {number, plural, other {# 分鐘}}",
  "time_remaining.moments": "剩餘時間",
  "time_remaining.seconds": "剩餘 {number, plural, other {# 秒}}",
  "trends.counter_by_accounts": "{count, plural, other {{counter} 人}}於過去 {days, plural, other {{days} 日}}之間",
  "trends.trending_now": "現正熱門趨勢",
  "ui.beforeunload": "如果離開 Mastodon，您的草稿將會不見。",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "拖放來上傳",
  "upload_button.label": "上傳圖片、影片、或者音訊檔案",
  "upload_error.limit": "已達到檔案上傳限制。",
  "upload_error.poll": "不允許於投票時上傳檔案。",
  "upload_error.quote": "引用嘟文無法上傳檔案。",
  "upload_form.drag_and_drop.instructions": "請按空白鍵或 Enter 鍵選取多媒體附加檔案。使用方向鍵移動多媒體附加檔案。按下空白鍵或 Enter 鍵於新位置放置多媒體附加檔案，或按下 ESC 鍵取消。",
  "upload_form.drag_and_drop.on_drag_cancel": "移動已取消。多媒體附加檔案 {item} 已被放置。",
  "upload_form.drag_and_drop.on_drag_end": "多媒體附加檔案 {item} 已被放置。",
  "upload_form.drag_and_drop.on_drag_over": "多媒體附加檔案 {item} 已被移動。",
  "upload_form.drag_and_drop.on_drag_start": "多媒體附加檔案 {item} 已被選取。",
  "upload_form.edit": "編輯",
  "upload_progress.label": "上傳中...",
  "upload_progress.processing": "處理中...",
  "username.taken": "這個帳號已經被註冊過囉。請嘗試其他帳號",
  "video.close": "關閉影片",
  "video.download": "下載檔案",
  "video.exit_fullscreen": "退出全螢幕",
  "video.expand": "展開影片",
  "video.fullscreen": "全螢幕",
  "video.hide": "隱藏影片",
  "video.mute": "靜音",
  "video.pause": "暫停",
  "video.play": "播放",
  "video.skip_backward": "上一部",
  "video.skip_forward": "下一部",
  "video.unmute": "解除靜音",
  "video.volume_down": "降低音量",
  "video.volume_up": "提高音量",
  "visibility_modal.button_title": "設定可見性",
  "visibility_modal.direct_quote_warning.text": "若您儲存目前設定，引用嘟文將被轉為連結。",
  "visibility_modal.direct_quote_warning.title": "引用嘟文無法被內嵌於私訊中",
  "visibility_modal.header": "可見性與互動",
  "visibility_modal.helper.direct_quoting": "Mastodon 上發佈之私訊嘟文無法被其他使用者引用。",
  "visibility_modal.helper.privacy_editing": "嘟文發布後無法變更可見性。",
  "visibility_modal.helper.privacy_private_self_quote": "自我引用之私嘟無法設為公開可見。",
  "visibility_modal.helper.private_quoting": "Mastodon 上發佈之僅限跟隨者嘟文無法被其他使用者引用。",
  "visibility_modal.helper.unlisted_quoting": "當其他人引用您時，他們的嘟文也會自熱門時間軸隱藏。",
  "visibility_modal.instructions": "控制誰能與此嘟文互動。您亦能藉由<link>偏好設定 > 嘟文預設值</link>此設定套用至所有未來嘟文。",
  "visibility_modal.privacy_label": "可見性",
  "visibility_modal.quote_followers": "僅限跟隨者",
  "visibility_modal.quote_label": "誰能引用此嘟文",
  "visibility_modal.quote_nobody": "僅有我",
  "visibility_modal.quote_public": "所有人",
  "visibility_modal.save": "儲存"
}
